<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <p>{{ data.message }}</p>

  <!-- Show follow-up reason only if enabled -->
  <mat-form-field *ngIf="showFollowUpReason" class="full-width">
    <mat-label>Reason</mat-label>
    <textarea matInput formControlName="reason" rows="3"></textarea>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="warn" (click)="onCancel()" *ngIf="!data.hideNoButton">
    {{ data.noText || "No" }}
  </button>
  <button mat-raised-button color="primary" (click)="onConfirm()">
    {{ data.yesText || "Yes" }}
  </button>
</mat-dialog-actions>
